import React from "react";
import { ExperimentManagementCard } from "./ExperimentManagementCard";
import * as actions from "../../../../redux/actions/experimentManagementAction";
import { useDispatch } from "react-redux";
export function ExperimentManagementPage() {
  const dispatch = useDispatch();
  dispatch(actions.fetchExperiments(1, 10, ""));
  return <ExperimentManagementCard />;
}
